import { useEffect, useState } from "react";
import { useLocation, useNavigate, useOutletContext } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import Pagination from "react-js-pagination";

import Product from "./productList/product.jsx";
import { findTargetMenuName } from "../../common/function/shopping.jsx";
import useQueryString from "../../../../hooks/useQueryString.jsx";

import { ListContainer, SectionContainer } from "./styled.js";

import { FaBars } from "react-icons/fa6";
import axios from "axios";

export default function ProductList() {
  const { url, theme, menus, cmpnyNo } = useOutletContext();
  const { pathname } = useLocation();

  const [totalCount, setTotalCount] = useState(0);
  const queryPage = Number(useQueryString("page"));
  const [currentPage, setCurrentPage] = useState(queryPage || 1);
  const [product, setProduct] = useState([]);

  const isMain = pathname === `/shop/${url}` || pathname === `/shop/${url}/`;

  useEffect(() => {
    if (cmpnyNo) {
      getPrductList();
    }
  }, [cmpnyNo]);

  const getPrductList = async (page = 0) => {
    try {
      const url = "/erp/vendorProducts/get";
      const query = `
        query VendorProducts(
          $cmpnyNo: Int!
          $offset: Int!
          $limit: Int!
        ) {
          vendorProducts(
            filter: {
              cmpnyNo: $cmpnyNo
              offset: $offset
              limit: $limit
            }
          ) {
            totalCount
            products {
              id
              name
              brand
              categoryId
              media
              price
            }
          }
        }
      `;

      const variables = {
        cmpnyNo: parseInt(cmpnyNo, 10),
        limit: 8,
        offset: page * 8,
      };
      const body = { query, variables };
      const res = await axios.post(url, body);

      if (res.status === 200) {
        setProduct(res.data.products);
        setTotalCount(res.data.totalCount);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const nextPage = (num) => {
    setCurrentPage(num);
    getPrductList(num - 1);
  };

  return (
    <SectionContainer className={`theme-${theme}`}>
      {!isMain && (
        <h3>
          <span>{findTargetMenuName(menus, 1)}</span>
        </h3>
      )}
      {!isMain && (
        <div className="count">
          <FaBars />
          상품
          <strong> {totalCount}</strong>
          개가 등록되어 있습니다.
        </div>
      )}
      <ListContainer className={`product theme-${theme}`}>
        {product.map((item) => (
          <Product item={item} url={url} />
        ))}
      </ListContainer>
      {!isMain && product && product.length > 0 && (
        <Pagination
          activePage={currentPage}
          itemsCountPerPage={8}
          totalItemsCount={totalCount}
          pageRangeDisplayed={3}
          prevPageText={"‹"}
          nextPageText={"›"}
          onChange={nextPage}
        />
      )}
    </SectionContainer>
  );
}
